import {join} from "./data";

export const applyClassName = (className, props = {}) => {
    const cn = join([className, props.className], ' ');
    if(cn) return {className: cn};
    return {};
};
